import type { PriceListResource, VariantResource } from "@exonn/js-sdk";
import { computePriceListItemFromPriceList } from "src/admin/modules/product/utils/computePriceListItemFromPriceList.tsx";
import { computeFinalPriceListItemPrice } from "src/admin/modules/product/utils/computeFinalPriceListItemPrice.ts";

export const computeSetPrice = ({
  variant,
  priceList,
}: {
  priceList?: PriceListResource;
  variant: VariantResource;
}) => {
  const components = variant.components!;

  if (!priceList) {
    return components.reduce((acc, component) => {
      const price = +component.price * +component.quantity;
      return acc + price;
    }, 0);
  }

  return components.reduce((acc, component) => {
    const componentPriceListItem = component.priceListItems!.find(
      (priceListItem) => priceListItem.priceList!.id === priceList.id,
    );
    const price = +component.price * +component.quantity;

    const computedPriceListItem = computePriceListItemFromPriceList({
      priceList,
    });

    const priceListItem = componentPriceListItem || computedPriceListItem;

    const priceListItemPrice = priceListItem
      ? computeFinalPriceListItemPrice({
          priceListItem: priceListItem,
          price: price,
        })
      : price;

    return acc + priceListItemPrice;
  }, 0);
};
